import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Real-time subscription to all round documents.
 * Returns an object keyed by round ID: { group, r32, r16, qf, sf, final, third }
 */
export function useRounds() {
  const [rounds, setRounds] = useState({});

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'rounds'), (snap) => {
      const data = {};
      snap.docs.forEach((d) => {
        data[d.id] = { id: d.id, ...d.data() };
      });
      setRounds(data);
    }, (err) => console.error('rounds subscription error:', err));
    return unsub;
  }, []);

  return rounds;
}
